import {Fragment} from "react";
import {Box, CircularProgress, Divider, Grid, Typography} from "@mui/material";
import {LABEL_DOWNLOAD_URL_PREFIX} from "../../Utils/apiUrl";

export const WordPressQuoteRatingMoving = ({
                                               movingRate,
                                               packageRate,
                                               packageError,
                                               packageLoading,
                                               isAbleGetPackageRate,
                                               redirectToApp,
                                               lng,
                                               NoRate,
                                               RegisterLink,
                                               Coupon,
                                               Feedback
                                           }) => {

    if (!movingRate?.totalCharge || +movingRate?.totalCharge === 0) {
        return (
            <Fragment>
                <Grid size={{xs: 12}}>
                    <NoRate/>
                </Grid>
                <Grid size={{xs: 12}}>
                    <Feedback/>
                </Grid>
                <Grid size={{xs: 12}}>
                    <RegisterLink/>
                </Grid>
                <Grid size={{xs: 12}}>
                    <Coupon/>
                </Grid>
                {redirectToApp()}
            </Fragment>
        )
    }

    return (
        <Fragment>
            <Grid size={{xs: 12}}>
                <Grid container spacing={isAbleGetPackageRate ? 2 : 4}>
                    <Grid size={{xs: 12}}>
                        <Typography sx={{fontWeight: '600'}}>
                            {lng === 'cn' ? '搬家服务' : "Moving Service"}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 6}}>
                        <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                            {lng === 'cn' ? '小计' : "Subtotal"}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 6}}>
                        <Typography sx={{fontSize: '16px', textAlign: 'right'}}>
                            $ {(+movingRate?.totalCharge).toFixed(2)}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 6}}>
                        <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                            {lng === 'cn' ? '税费' : "Tax"}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 6}}>
                        <Typography sx={{fontSize: '16px', textAlign: 'right'}}>
                            $ {(+movingRate?.taxCharge || 0).toFixed(2)}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 12}}>
                        <Divider/>
                    </Grid>
                    <Grid size={{xs: 6}}>
                        <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                            {lng === 'cn' ? '总计' : "Total"}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 6}}>
                        <Typography sx={{fontSize: '16px', textAlign: 'right'}}>
                            $ {(+movingRate?.totalChargeWithTaxes)?.toFixed(2)}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid size={{xs: 12}}>
                <Grid container spacing={2}>
                    {
                        isAbleGetPackageRate &&
                        <>
                            <Grid size={{xs: 12}}>
                                <Divider/>
                            </Grid>
                            <Grid size={{xs: 12}}>
                                <Typography sx={{fontWeight: '600'}}>
                                    {lng === 'cn' ? '替代选择：快递服务' : "Alternative Option: Courier Service"}
                                </Typography>
                            </Grid>
                        </>
                    }
                    {
                        isAbleGetPackageRate &&
                        (
                            packageLoading ?
                                <Grid size={{xs: 12}}>
                                    <Box sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}>
                                        <CircularProgress/>
                                    </Box>
                                </Grid>
                                :
                                (packageError || packageRate?.length === 0) ?
                                    <Grid size={{xs: 12}}>
                                        <Typography>
                                            {lng === 'cn' ? '根据您当前的选择，您也可以考虑使用我们的快递服务作为替代运输方案。不过，系统无法实时生成报价。' : "Based on your current selections, you may also consider our courier service as an alternative shipping method. However, we cannot provide you with an immediate quote."}
                                        </Typography>
                                    </Grid>
                                    :
                                    <>
                                        <Grid size={{xs: 12}}>
                                            <Typography>
                                                {lng === 'cn' ? '根据您当前的选择，您也可以考虑使用我们的快递服务作为替代运输方案。' : "Based on your current selections, you may also consider our courier service as an alternative shipping method."}
                                            </Typography>
                                        </Grid>
                                        <Grid size={{xs: 4}}>
                                            <Typography>
                                                {lng === 'cn' ? '承运商' : "Carrier"}
                                            </Typography>
                                        </Grid>
                                        <Grid size={{xs: 4}}>
                                            <Typography>
                                                {lng === 'cn' ? '运输天数' : "Transit Days"}
                                            </Typography>
                                        </Grid>
                                        <Grid size={{xs: 4}}>
                                            <Typography>
                                                {lng === 'cn' ? '费用' : "Cost"}
                                            </Typography>
                                        </Grid>
                                        <Grid size={{xs: 12}}>
                                            <Divider/>
                                        </Grid>
                                        {
                                            packageRate?.slice(0, 3)?.map((rate, index) => (
                                                <Fragment key={index}>
                                                    <Grid size={{xs: 4}}>
                                                        <Box>
                                                            <img src={`${LABEL_DOWNLOAD_URL_PREFIX}${rate?.icon_uri}`}
                                                                 alt="icon"
                                                                 width='40px'/>
                                                        </Box>
                                                    </Grid>
                                                    <Grid size={{xs: 4}}>
                                                        <Typography>
                                                            {rate?.shipRange || '2 - 10'} days
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={{xs: 4}}>
                                                        <Typography>
                                                            $ {(+rate?.finalTotalAmount?.value)?.toFixed(2)} {rate?.finalTotalAmount?.currency}
                                                        </Typography>
                                                    </Grid>
                                                </Fragment>
                                            ))
                                        }
                                    </>
                        )
                    }
                </Grid>
            </Grid>
            <Grid size={{xs: 12}}>
                <br/>
                <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                    {lng === 'cn' ? '价格说明' : "Price Disclaimer"}
                </Typography>
                <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                    {lng === 'cn' ? '显示的搬家价格为系统预估价格，仅供参考。' : "The moving price is a system-generated estimate for reference only."}
                </Typography>
                <br/>
                <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                    {lng === 'cn' ? '搬家费用会根据多项因素动态变化，包括但不限于：' : "Moving costs may vary based on multiple factors, including but not limited to:"}
                </Typography>
                <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                    -{lng === 'cn' ? '实际取件与送达地址（是否偏远地区）' : "Exact pickup and delivery locations (remote areas may affect pricing)"}
                </Typography>
                <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                    -{lng === 'cn' ? '物品清单的完整度、体积、重量及特殊物品' : "Completeness of the item list, total volume, weight, and special items"}
                </Typography>
                <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                    -{lng === 'cn' ? '是否需要打板、拆装、上楼、电梯预约等额外服务' : "Additional services such as palletizing, disassembly/reassembly, stairs, elevator booking, etc."}
                </Typography>
                <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                    -{lng === 'cn' ? '当期人工、运输资源及路线安排' : "Current labor availability, transportation resources, and routing conditions"}
                </Typography>
                <br/>
                <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                    {lng === 'cn' ? '在未获取完整信息前，系统无法给出准确报价。 最终价格请以人工确认后的正式报价为准。如需准确价格，欢迎提交询价或直接联系我们的客服团队。' : "Final pricing will be confirmed manually and may differ from the estimate shown. Please submit an inquiry or contact our team for an accurate quote."}
                </Typography>
            </Grid>
            <Grid size={{xs: 12}}>
                <Feedback/>
            </Grid>
            <Grid size={{xs: 12}}>
                <RegisterLink/>
            </Grid>
            <Grid size={{xs: 12}}>
                <Coupon/>
            </Grid>
            {
                redirectToApp()
            }
        </Fragment>
    )
}